import ReactApexChart from 'react-apexcharts';

interface AreaChartProps {
	data: number[];
	categories: string[];
	color: string;
	height?: number;
}

const AreaChart = ({ data, categories, color, height = 75 }: AreaChartProps) => {
	const options: ApexCharts.ApexOptions = {
		chart: {
			type: 'line',
			sparkline: {
				enabled: true,
			},
			toolbar: {
				show: false,
			},
			animations: {
				enabled: false,
			},
		},
		stroke: {
			curve: 'smooth',
			width: 2,
		},
		colors: [color],
		tooltip: {
			fixed: {
				enabled: false,
			},
			x: {
				show: false,
			},
			y: {
				title: {
					formatter() {
						return '';
					},
				},
			},
			marker: {
				show: false,
			},
		},
		xaxis: {
			categories,
			labels: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
			},
		},
		yaxis: {
			show: false,
		},
		grid: {
			show: false,
			padding: {
				left: 0,
				right: 0,
				top: 0,
				bottom: 0,
			},
		},
	};

	const series = [
		{
			name: 'Value',
			data,
		},
	];

	return (
		<div className="h-12">
			<ReactApexChart options={options} series={series} type="area" height={height} />
		</div>
	);
};

export { AreaChart };
